/**
 * resumeExportSimple.js
 * Template registry — 3 premium ATS-safe templates.
 * Used by the template picker UI in the Review step.
 */

export const resumeTemplates = {
  startup: {
    name: 'The Startup',
    category: 'Modern Tech',
    description: 'Clean Inter font, generous whitespace, high-contrast headings.',
    level: 'All Levels',
    colors: { primary: '#0ea5e9', secondary: '#0f172a', accent: '#0ea5e9' },
    layout: 'single-column',
    preview: { headerBg: '#0ea5e9', sectionLine: '#0ea5e9', bullet: '•' },
  },
  executive: {
    name: 'The Executive',
    category: 'Leadership',
    description: 'Elegant Lora serif, centered authority, recruiter-trusted classic.',
    level: 'Senior/Lead',
    colors: { primary: '#171717', secondary: '#52525b', accent: '#171717' },
    layout: 'single-column',
    preview: { headerBg: '#171717', sectionLine: '#171717', bullet: '•' },
  },
  engineer: {
    name: 'The Engineer',
    category: 'Technical',
    description: 'Roboto Mono accents, left-aligned structured data density.',
    level: 'SDET / Automation',
    colors: { primary: '#064e3b', secondary: '#374151', accent: '#10b981' },
    layout: 'single-column',
    preview: { headerBg: '#064e3b', sectionLine: '#10b981', bullet: '›' },
  },
  modern_split: {
    name: 'Modern Split',
    category: 'Advanced Design',
    description: 'A striking 30/70 dual-column layout with a colored sidebar.',
    level: 'Design/Frontend QA',
    colors: { primary: '#6366f1', secondary: '#4338ca', accent: '#4f46e5' },
    layout: 'two-column',
    preview: { headerBg: '#6366f1', sectionLine: '#6366f1', bullet: '•' },
  },
  data_driven: {
    name: 'Data-Driven',
    category: 'Advanced Design',
    description: 'Solid header block with visual progress dots for skills.',
    level: 'Tech Lead / Manager',
    colors: { primary: '#0f172a', secondary: '#1e293b', accent: '#0f172a' },
    layout: 'single-column',
    preview: { headerBg: '#0f172a', sectionLine: '#0f172a', bullet: '▪' },
  },
  timeline: {
    name: 'The Timeline',
    category: 'Advanced Design',
    description: 'Sleek vertical timeline connecting experience and education.',
    level: 'Senior/Principal',
    colors: { primary: '#111827', secondary: '#374151', accent: '#111827' },
    layout: 'single-column',
    preview: { headerBg: '#111827', sectionLine: '#111827', bullet: '-' },
  }
};

// Re-export everything from the real engine so existing imports keep working
export {
  buildResumeHTML,
  downloadResumePDF,
  previewResume,
  printResume,
  downloadHTML,
  downloadResume,
} from './resumeExport';
